import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { SigningFlowRequest } from '../models/request/SigningFlowRequest';
import { SigningFlowResponse } from '../models/response/SigningFlowResponse';
import { SigningFileRequest } from '../models/request/SigningFileRequest';
import { SigningFlowsResponse } from '../models/response/SigningFlowsResponse';

@Injectable({
    providedIn: 'root'
})
export class HttpSigningFlowService {

    private baseApiUrl = this.trimTrailingSlash(environment.signingFlowsApi.uri);

    constructor(private http: HttpClient) { }

    postSigningFlow(request: SigningFlowRequest): Observable<any> {
        const url = `${this.baseApiUrl}`;
        // const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` });
        return this.http.post<any>(url, request);
    }

    getSigningFlowsWithLimit(creator: string, skip: number, limit: number, filter: string | undefined): Observable<SigningFlowsResponse> {
        var url = `${this.baseApiUrl}?creator=${creator}&skip=${skip}&limit=${limit}&filter=${filter}`;
        // const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` });
        
        return this.http.get<SigningFlowsResponse>(url);
    }

    getSigningFlow(referenceCode: string): Observable<SigningFlowResponse> {
        const url = `${this.baseApiUrl}/${referenceCode}`;
        // const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` });
        
        return this.http.get<SigningFlowResponse>(url);
    }

    updateSigningFlow(request: SigningFlowRequest, referenceCode: string): Observable<any> {
        const url = `${this.baseApiUrl}/${referenceCode}`;
        // const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` });
        
        return this.http.put<any>(url, request);
    }

    getSigningFlowFile(referenceCode: string): Observable<HttpResponse<Blob>> {
        const url = `${this.baseApiUrl}/${referenceCode}/file`;
        // const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` });

        return this.http.get(url, {
            responseType: 'blob',
            observe: 'response'
        });
    }

    updateSigningFlowFile(request: SigningFileRequest, referenceCode: string): Observable<any> {
        const url = `${this.baseApiUrl}/${referenceCode}/file`;
        // const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` });
        
        return this.http.put<any>(url, request);
    }

    cancelSigningFlow(referenceCode: string): Observable<any> {
        const url = `${this.baseApiUrl}/${referenceCode}/cancel`;
        // const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` });
        
        return this.http.delete<any>(url);
    }

    // Ak adresa konci "/", tak ho odstrani
    trimTrailingSlash(url: string): string {
        return url.endsWith('/') ? url.slice(0, -1) : url;
    }
}
